import { HTMLStencilElement } from "@stencil/core/internal";
import windowService from "../services/window-service";
import { Timeout } from "./timeout";

export async function componentsOnReady(
  parent: HTMLElement | null,
  timeout: Timeout,
  ...selectors: string[]
): Promise<HTMLElement[] | null> {
  if (parent === null) {
    return null;
  }
  const waitForElement = async (selector?: string): Promise<HTMLElement> => {
    const el = await windowService.waitForElement(parent, selector);

    if (typeof (el as HTMLStencilElement)?.componentOnReady === "function") {
      await (el as HTMLStencilElement).componentOnReady();
    }

    return el;
  };

  const waitForElements =
    selectors.length > 0
      ? selectors.map(waitForElement)
      : [await waitForElement()];

  const timer = new Promise<null>((resolve) =>
    timeout.set(() => resolve(null)),
  );
  return Promise.race([Promise.all(waitForElements), timer]);
}
